// Responsive art from the generated image set: AVIF, then WebP, then JPEG (older iPads).
import images from '../generated/images.json';

type ImageId = keyof typeof images;

interface PictureProps {
  id: ImageId | (string & {});
  alt: string;
  className?: string;
  /** Load immediately (above the fold); otherwise lazy. */
  priority?: boolean;
  /** CSS sizes attribute; defaults to full viewport width. */
  sizes?: string;
  /** Projector view may use the full native width; student screens stay at or below 1280 px. */
  projector?: boolean;
}

export function Picture({ id, alt, className, priority, sizes = '100vw', projector }: PictureProps) {
  const entry = (images as Record<string, { widths: number[]; aspect: number }>)[id];
  if (!entry) return null;
  const widths = entry.widths.filter((w) => projector || w <= 1280);
  const set = (ext: string) => widths.map((w) => `/assets/img/${id}-${w}.${ext} ${w}w`).join(', ');
  const fallback = `/assets/img/${id}-${widths[widths.length - 1]}.jpg`;
  return (
    <picture className={className}>
      <source type="image/avif" srcSet={set('avif')} sizes={sizes} />
      <source type="image/webp" srcSet={set('webp')} sizes={sizes} />
      <img
        src={fallback}
        srcSet={set('jpg')}
        sizes={sizes}
        alt={alt}
        loading={priority ? 'eager' : 'lazy'}
        decoding="async"
        fetchPriority={priority ? 'high' : 'auto'}
        style={{ aspectRatio: String(entry.aspect) }}
      />
    </picture>
  );
}
